"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchContractTemplatesTree = fetchContractTemplatesTree;
/**
 * Drzewo struktury umowy — typy kamieni milowych, typy spraw i foldery
 * opcjonalne dostępne dla danego typu umowy.
 *
 * Celowo NIE korzysta z RepositoryReact: ten mówi wyłącznie POST-em
 * z `orConditions` i zwraca listę obiektów z `id`, a tu jest GET z parametrem
 * zwracający zagnieżdżony obiekt bez `id`. Do tego cache'uje do sessionStorage
 * pod kluczem będącym samą nazwą repozytorium, więc przełączenie typu umowy
 * podałoby drzewo poprzedniego typu.
 *
 * Fetch idzie przez ToolsFetch, żeby 401 kończył się przejściem do logowania,
 * a brak sieci czytelnym komunikatem — ręczny fetch to gubił i użytkownik
 * z wygasłą sesją widziałby „nie udało się wczytać struktury".
 */
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const ToolsFetch_1 = __importDefault(require("../../../React/Tools/ToolsFetch"));
async function fetchContractTemplatesTree(contractTypeId) {
    return ToolsFetch_1.default.fetchJsonWithSafeError(`${MainSetupReact_1.default.serverUrl}contractTemplatesTree?contractTypeId=${contractTypeId}`, { method: "GET", credentials: "include" });
}
